/**
 * Multi select within a dropdown
 * Replaces select[multiple] html entities with custom dropdowns utilizing checkbox arrays
 * 
 * @author Michael Zenner <mzenner@perrill.com>
 * @version 1.0.0
 * @since 2024-06-20
 * 

 * 
 *** Html Usage:
 * 

 * Instructions:
 * Create a select field with the "multiple" attribute
 * Set your desired name attribute. Make sure you use the [] to make it an array
 * 
 * Parameters:
 * placeholder (optional) - allows you to choose a custom placeholder
 * data-icon (optional) - allows you to add a font awesome icon before the placeholder

<select name="sample_name[]" 
        multiple 
        placeholder="Select Optons"
        data-icon="fa-solid fa-circle-notch">
  <option value="1">Option 1</option>
  <option value="2">Option 2</option>
  <option value="3">Option 3</option>
</select>

 * 
 */

MultiSelectDropdown = new function()
{
  this.init = function() {
    jQuery('select[multiple]').each(function(index, el) {
      MultiSelectDropdown.initLibrary(el);
    });

    jQuery('body').on('click', '.select-multiple .placeholder', function(event) {
      jQuery(this).next('.dropdown').toggle();
    });

    jQuery('body').on('click', '.select-multiple a.close', function(event) {
      event.preventDefault();
      jQuery(this).closest('.select-multiple').find('.dropdown').hide();
    });

    $('html').click(function(e) {
        if(!$(e.target).closest(".select-multiple").length) {
            jQuery('.select-multiple .dropdown').hide();
        }
    });
  };

  this.initLibrary = function(el) {
    var placeholder = jQuery(el).attr('placeholder');
    var name        = jQuery(el).attr('name');
    var icon        = jQuery(el).attr('data-icon');

    var html = '';
    html += '<div class="select-multiple">';
    html += '<div class="placeholder">';
    if(icon) {
      html += '<i class="' + icon + '"></i>';
    }
    html += placeholder + '</div>';
    html += '<div class="dropdown">';

    jQuery(el).find('option').each(function(index, el) {
      var value = jQuery(el).val();
      var text  = jQuery(el).text();

      html += '<div class="option">';
      var isSelected = jQuery(el).is(':selected') ? 'checked' : '';
      html += '<input type="checkbox" id="' + name + value + '" name="' + name + '" value="' + value + '" ' + isSelected + '>';
      html += '<label for="' + name + value + '">' + text + '</label>';
      html += '</div>';
    });

    html += '<a href="javascript:;" class="close">Apply</a>';
    html += '</div>';
    html += '</div>';

    jQuery(el).after(html);
    jQuery(el).remove();
  };
}

jQuery(document).ready(function($) {
  MultiSelectDropdown.init();
});
